import { FunctionComponent, ReactElement } from "react";
import { Link } from "react-router-dom";

interface ITableRowsProps {
  rows: any[][];
}

const TableRows: FunctionComponent<ITableRowsProps> = ({ rows }) => (
  <tbody>
    {rows.map((row, i) => (
      <tr
        key={i}
        className="even:bg-white/5 odd:bg-white/0 hover:bg-primary/10 transition-colors duration-300"
      >
        {row.map((cell: string | ReactElement, j) => (
          <td key={j} className="px-4 py-3 text-black">
            <Link to={`/dashboard/consultant/clients/${row[1]}`}>{cell}</Link>
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default TableRows;
